import CodeList from '@/modules/common/domain/codeList'

class PaymentType extends CodeList {
  statementEnabled?: boolean | null
}

export default PaymentType
